// -----------------------------
// theme.js voor Shopify BELLE (verbeterde basis)
// -----------------------------

// 1. JQUERY & UNDERSCORE/Lodash VÓÓR deze code laden! (anders error)
//    <script src=".../jquery.min.js"></script>
//    <script src=".../underscore.min.js"></script>
//    <script src=".../theme.js"></script>

window.theme = window.theme || {};

// Check of underscore/lodash geladen is
if (typeof _ === 'undefined') {
  console.error('Underscore.js of Lodash is vereist voor theme.js!');
}

// ---------------------
// Sections Handler
// ---------------------
theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];
  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};
theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');
    constructor = constructor || this.constructors[type];
    if (_.isUndefined(constructor)) return;
    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });
    this.instances.push(instance);
  }
  // Overige methods kun je aanvullen indien nodig
});

// ---------------------------------------
// Section-constructors veilig registreren
// ---------------------------------------
theme.HeaderSection = theme.HeaderSection || function () {};
theme.Product = theme.Product || function () {};
theme.collectionView = theme.collectionView || function () {};
theme.SlideshowSection = theme.SlideshowSection || function () {};
theme.carousel = theme.carousel || function () {};
theme.Quotes = theme.Quotes || function () {};
theme.masonary = theme.masonary || function () {};
theme.instagramSection = theme.instagramSection || function () {};

// --------------------
// Theme init
// --------------------
theme.init = function () {
  // Plaats hier je globale initialisaties
  // Voorbeeld: console.log("Theme init geladen!");
};

// ------------------------
// Document ready
// ------------------------
$(function () {
  // Init sections
  var sections = new theme.Sections();
  sections.register('header', theme.HeaderSection);
  sections.register('product', theme.Product);
  sections.register('collection-template', theme.collectionView);
  sections.register('slideshow', theme.SlideshowSection);
  sections.register('carousel', theme.carousel);
  sections.register('quotes', theme.Quotes);
  sections.register('masonary', theme.masonary);
  sections.register('instagram', theme.instagramSection);

  // Theme init
  theme.init();
});

// ------------------------
// Buy knop click handler
// ------------------------
$(document).on('click', '.add-to-cart', function (e) {
  e.preventDefault();
  $('body').addClass('loading');
  try {
    var $btn = $(this).next().find('.cartBtn');
    if ($btn.length) {
      $btn.trigger('click');
    } else {
      console.warn('Geen cartBtn gevonden!');
    }
  } catch (err) {
    console.error('Fout bij toevoegen aan winkelmandje:', err);
  }
  $('body').removeClass('loading');
});

// ------------------------
// Wishlist fallback
// ------------------------
if (typeof localStorage !== 'undefined') {
  // Je wishlist code hier
}

// ------------------------
// AJAX met error handling
// ------------------------
function ajaxfilter(url) {
  $.ajax({
    type: 'GET',
    url: url,
    beforeSend: function () {
      $('body').addClass('loading hideOverly');
    },
    complete: function () {
      $('body').removeClass('loading hideOverly');
    },
    error: function (xhr, status, error) {
      $('body').removeClass('loading hideOverly');
      console.error('Ajax fout:', error);
      // Eventueel melding op scherm tonen
    }
    // success: function(data){ ... }
  });
}


